var _circle, _circle2, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "#F7AD00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    stroke: "#F7AD00",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1826_6312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1826_6312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 65C49.0834 65 48.2987 64.6736 47.6459 64.0208C46.9931 63.3681 46.6667 62.5833 46.6667 61.6667C46.6667 60.75 46.9931 59.9653 47.6459 59.3125C48.2987 58.6597 49.0834 58.3333 50.0001 58.3333C50.9167 58.3333 51.7015 58.6597 52.3542 59.3125C53.007 59.9653 53.3334 60.75 53.3334 61.6667C53.3334 62.5833 53.007 63.3681 52.3542 64.0208C51.7015 64.6736 50.9167 65 50.0001 65ZM46.6667 55V35H53.3334V55H46.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.5d86663154295dde6dedd2c9d4d4e52d.svg";
export { ForwardRef as ReactComponent };